import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { IEvent } from "../../../../models/Event"
import { faWaze } from '@fortawesome/free-brands-svg-icons'
import React from "react";

export const Location: React.FC<{ event: IEvent }> = ({ event }) => {
    return (
        <div className="location-container">
            <div className="meeting-point">
                <h2 className="panel-title">הגעה לשטח כינוס</h2>
                <a className="btn btn-primary" href={event.wazeDirection} target='_blank' rel="noreferrer">
                    <FontAwesomeIcon icon={faWaze} />
                    ניווט עם Waze
                </a>
            </div>
        </div >
    )
}
